import { Observable, of } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import {
  ApplicationProviderService,
  AllRule,
  ResourceTypeRule,
  ResourceGroupRule,
} from '../account/services/application.service'
import { ApiService } from '../services/api.service'
import { ensureAwsAccount$ } from './resource-selector-base'
import { resourceSelectionsAsSets, ResourceSelections } from './app-resources-selector/app-resources-selector.component'
import { Tag } from 'src/utils/types'
import { ApplicationType } from '../services/dtos'

export interface CreateApplicationParams {
  accountId: string
  applicationType: ApplicationType
  applicationName: string
  applicationRpo: number
  applicationNotificationEmails: string[]
  sourceEndpointUri: string
  targetEndpointUri: string
  targetAccountId: string
  matchingRules: Array<Tag | AllRule | ResourceTypeRule | ResourceGroupRule>
  excludingRules: Array<Tag | AllRule | ResourceTypeRule | ResourceGroupRule>
  resourceSelections: ResourceSelections
  identityProviderId?: string
}

export class ApplicationSaveUtility {
  static createApplication$(
    params: CreateApplicationParams,
    applicationProviderService: ApplicationProviderService,
    apiService: ApiService
  ): Observable<any> {
    let ensureAwsAccount = of(null)

    if (params.applicationType === ApplicationType.AWS) {
      ensureAwsAccount = ensureAwsAccount$(apiService, params.accountId, params.targetAccountId)
    }

    return ensureAwsAccount.pipe(
      switchMap((_awsAccountDto: any) => {
        const { selectedResources: matchingArns, suppressedResources: excludedWeakArns } = resourceSelectionsAsSets(
          params.resourceSelections
        )

        return applicationProviderService.createApplication$(
          params.accountId,
          params.applicationType,
          params.applicationName,
          params.applicationRpo,
          params.applicationNotificationEmails,
          params.sourceEndpointUri,
          params.targetEndpointUri,
          params.matchingRules,
          params.excludingRules,
          matchingArns,
          excludedWeakArns,
          params.identityProviderId
        )
      })
    )
  }
}
